import React from "react";
import { useNavigate } from "react-router-dom";
import blurLoading from "../assets/images/blurLoading.png";

const ComingSoon = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-[url('assets/images/bgLoading.jpg')] bg-cover bg-fixed bg-center min-h-screen relative flex items-center justify-center px-4 overflow-hidden w-full">

      {/* Decorative blurred image at the bottom left */}
      <img
        src={blurLoading}
        alt="blurLoading"
        className="absolute bottom-0 left-0 pointer-events-none"
      />

      {/* Main card */}
      <div className="text-center relative z-10 max-w-lg mb-20 bg-black/40 p-10 rounded-3xl backdrop-blur-md border border-[#FBE67B]/20 shadow-2xl">

        {/* Title */}
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-black leading-tight text-[#FBE67B] drop-shadow-lg mb-4 uppercase tracking-widest">
          Coming Soon
        </h1>

        {/* Divider */}
        <div className="w-16 h-1 bg-[#FBE67B]/50 mx-auto mb-6 rounded-full" />

        {/* Subtitle */}
        <p className="text-gray-200 text-sm md:text-base lg:text-lg mb-8 leading-relaxed font-medium px-4">
          Tính năng này đang trong quá trình hoàn thiện để mang đến trải nghiệm tuyệt vời nhất. <br /> Sẽ sớm ra mắt!
        </p>

        {/* Back Button */}
        <button
          onClick={() => navigate("/the-flame-vine/locations")}
          className="border-0 group relative inline-flex items-center gap-2 px-8 py-3.5 bg-[#FBE67B] text-[#50184b] font-bold rounded-full shadow-lg shadow-[#FBE67B]/25 hover:shadow-[#FBE67B]/40 transition-all duration-300 hover:scale-105 active:scale-95 uppercase tracking-wider text-xs md:text-sm"
        >
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 transition-transform duration-300 group-hover:-translate-x-1"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M10 19l-7-7m0 0l7-7m-7 7h18"
            />
          </svg> */}
          đến vị trí liên kết vùng
        </button>
      </div>
    </div>
  );
};

export default ComingSoon;
